export function isUserInventoryOwner(inventory, userId) {
  return userId === inventory.ownerId;
}